<template>
  <GdashTile
    icon="<path d='M5,6H23V18H5V6M14,9A3,3 0 0,1 17,12A3,3 0 0,1 14,15A3,3 0 0,1 11,12A3,3 0 0,1 14,9M9,8A2,2 0 0,1 7,10V14A2,2 0 0,1 9,16H19A2,2 0 0,1 21,14V10A2,2 0 0,1 19,8H9M1,10H3V20H19V22H1V10Z' />"
    header="Household Income"
  >
    <div class="tile-description">
      The average income is <b>{{ data.medianIncome | format("c0") }}</b>
    </div>
    <wj-flex-chart
      class="chart chart-bar-stacked"
      chartType="Bar"
      stacking="Stacked100pc"
      :itemsSource="getIncome()"
      :palette="palette"
    >
      <wj-flex-chart-axis wjProperty="axisY" position="None" />
      <wj-flex-chart-axis wjProperty="axisX" position="None" />
      <wj-flex-chart-data-label content="{y}" position="Left" :offset="0" />
      <wj-flex-chart-series name="Under 75k" binding="value1" />
      <wj-flex-chart-series name="75k to 150k" binding="value2" />
      <wj-flex-chart-series name="150k and above" binding="value3" />
      <wj-flex-chart-legend position="Bottom" />
    </wj-flex-chart>
  </GdashTile>
</template>

<script>
import GdashTile from "./GdashTile.vue";
import * as wjcCore from "@mescius/wijmo";

export default {
  name: "HouseholdIncomeTile",
  components: {
    GdashTile,
  },

  props: {
    data: Object,
    palette: Array,
  },
  filters: {
    format(value, fmt) {
      return wjcCore.Globalize.format(value, fmt);
    },
  },
  methods: {
    getIncome() {
      const data = this.data;
      const incomeData = [
        {
          value1: data.numHouses75k,
          value2: data.numHouses75_150k,
          value3: data.numHouses150k,
        },
      ];

      return incomeData;
    },
  },
};
</script>
